export const appConstants = {
  GET_TOKEN: 'GET_TOKEN',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGOUT_USER: 'LOGOUT_USER',
  GET_ARTICLE_CATEGORY_REQUEST: 'GET_ARTICLE_CATEGORY_REQUEST',
  GET_ARTICLE_CATEGORY_SUCCESS: 'GET_ARTICLE_CATEGORY_SUCCESS',
  GET_ARTICLE_CATEGORY_FAILED: 'GET_ARTICLE_CATEGORY_FAILED',
  GET_EVENT_SUCCESS: 'GET_EVENT_SUCCESS',
  GET_EVENT_REQUEST: 'GET_EVENT_REQUEST',
  GET_EVENT_FAILED: 'GET_EVENT_FAILED',
  DETAIL_EVENT_REQUEST: 'DETAIL_EVENT_REQUEST',
  DETAIL_EVENT_SUCCESS: 'DETAIL_EVENT_SUCCESS',
  DETAIL_EVENT_FAILED: 'DETAIL_EVENT_FAILED',
  GET_LATEST_REQUEST: 'GET_LATEST_REQUEST',
  GET_LATEST_SUCCESS: 'GET_LATEST_SUCCESS',
  GET_LATEST_ERROR: 'GET_LATEST_ERROR',
  GET_POPULAR_REQUEST: 'GET_POPULAR_REQUEST',
  GET_POPULAR_SUCCESS: 'GET_POPULAR_SUCCESS',
  GET_POPULAR_FAILED: 'GET_POPULAR_FAILED',
  DETAIL_ARTICLE_REQUEST: 'DETAIL_ARTICLE_REQUEST',
  DETAIL_ARTICLE_SUCCESS: 'DETAIL_ARTICLE_SUCCESS',
  DETAIL_ARTICLE_FAILED: 'DETAIL_ARTICLE_FAILED',
  DETAIL_EVENT: 'DETAIL_EVENT',
  GET_LIST_VOTE_REQUEST: 'GET_LIST_VOTE_REQUEST',
  GET_LIST_VOTE_SUCCESS: 'GET_LIST_VOTE_SUCCESS',
  GET_LIST_VOTE_FAILED: 'GET_LIST_VOTE_FAILED',
  SUBMIT_VOTE_REQUEST: 'SUBMIT_VOTE_REQUEST',
  SUBMIT_VOTE_SUCCESS: 'SUBMIT_VOTE_SUCCESS',
  SUBMIT_VOTE_FAILED: 'SUBMIT_VOTE_FAILED',
  GET_LIST_QUISIONER_REQUEST: 'GET_LIST_QUISIONER_REQUEST',
  GET_LIST_QUISIONER_SUCCESS: 'GET_LIST_QUISIONER_SUCCESS',
  GET_LIST_QUISIONER_FAILED: 'GET_LIST_QUISIONER_FAILED',
  GET_RESULT_QUISIONER: 'GET_RESULT_QUISIONER',
  INIT_DATA: 'INIT_DATA_STARTED'
}
